import { useLayoutEffect, useState } from 'react'
import type { RefObject } from 'react'
import type { SlashMenuPosition } from './SlashMenu'

interface ResolvedStyle {
  top: number
  left: number
  maxHeight: number
}

const MARGIN = 8

export const useSlashMenuStyle = (
  menuRef: RefObject<HTMLDivElement>,
  position: SlashMenuPosition | null,
  reflowKey: unknown,
): ResolvedStyle | null => {
  const [resolved, setResolved] = useState<ResolvedStyle | null>(null)

  useLayoutEffect(() => {
    if (!position || !menuRef.current) {
      setResolved(null)
      return
    }
    const el = menuRef.current
    const naturalHeight = el.scrollHeight
    const viewportHeight = window.innerHeight
    const spaceBelow = viewportHeight - position.cursorBottom - MARGIN
    const spaceAbove = position.cursorTop - MARGIN

    if (naturalHeight <= spaceBelow) {
      setResolved({
        top: position.cursorBottom + 4,
        left: position.left,
        maxHeight: spaceBelow,
      })
      return
    }
    if (spaceAbove > spaceBelow) {
      const maxHeight = Math.min(naturalHeight, spaceAbove)
      setResolved({
        top: position.cursorTop - maxHeight - 4,
        left: position.left,
        maxHeight,
      })
      return
    }
    setResolved({
      top: position.cursorBottom + 4,
      left: position.left,
      maxHeight: Math.max(120, spaceBelow),
    })
  }, [position, reflowKey, menuRef])

  return resolved
}
